/* 钛镁客户的接口 */
export default {
    taimeiLogin: {
        path: '/ump/v1/p/taimei/users/signup',
        method: 'post',
        noAuth: true,
    },
};
